<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  template(v-if="gamesList.includes(String(menu2)) && (String(menu0) == 'all') && (String(menu1) == 'today')")
    .content-center.egame
      egames(:keys="marketKeys" :key1="earlyMarketKeys" :key2="todayMarketKeys" :key3="liveMarketKeys" :items="marketList")
  template(v-else)
    .content-center
      //- small {{ menu0 }}|{{ menu1 }}|{{ menuY }}|{{ menu3 != 'parlay' }}
      template(v-if="['favorite','event'].includes(menu0)")
        .headline-bar
          .prematch.d-flex.align-items-center
            template(v-if="['favorite'].includes(menu0)")
              .headline-title
                img(src='/images/favorite-active.svg?v=12')
                span {{ $t("ui.favorites") }}
            template(v-else)
              .headline-title
                template(v-if="['event'].includes(menu0)")
                  template(v-if="menuY == 3")
                    img.png(src="/images/icon-sport-svg/worldcup.svg?v=12")
                    span {{ $t("ui.event_worldcup") }}
                  template(v-else-if="menuY == 2")
                    img.png(src="/images/icon-other/euro24.png?v=12")
                    span {{ $t("ui.event_euro") }}
                  template(v-else-if="menuY == 1")
                    img(src='/images/icon-other/copa24.png?v=12')
                    span {{ $t("ui.event_copa") }}
                  template(v-else-if="menuY == 4")
                    img(src='/images/icon-other/olympic24.png?v=12')
                    span {{ $t("ui.event_olympic") }}
                template(v-else)
                  img.png(v-if="menu2 == 41" :src="'/images/icon-sport-svg/' + menu2 + '.png?v=12'")
                  img(v-else :src="'/images/icon-sport-svg/' + menu2 + '.svg?v=12'")
                  span(:class=" menu2 != 42 ? 'text-capitalize' : 'text-uppercase'") {{ sportsName[menu2] }}
        template(v-if="['event'].includes(menu0)")
          .prematch-outright(v-if="['live','upcoming','early','today'].includes(menu1)")
            ul.p-0.m-0.d-flex.justify-content-center
              li
                a(href='javascript:void(0);' :class="{ 'active' : menu1 == 'live' && !['orz','parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="setMenu2(menuY,'live')")
                  img(src='/images/live-icon.svg')
                  | {{ $t("ui.live") }}
                  //- span.event-count {{ isMarketValid(liveMenu, false) ? liveMenu[menu2].tn : 0 }}              
              li
                a(href='javascript:void(0);' :class="{ 'active' : ['today','upcoming'].includes(menu1) && !['orz','parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="setMenu2(menuY,'today')")
                  | {{ $t("ui.today") }}  
                  //- span.event-count {{ isMarketValid(todayMenu, false) ? todayMenu[menu2].orz && todayMenu[menu2].orz > 0 ? todayMenu[menu2].tn - todayMenu[menu2].orz : todayMenu[menu2].tn : 0 }}
              li
                a.early-dropdown-btn(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && !['orz','parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="setMenu2(menuY,'early')")
                  | {{ $t("ui.early") }}
                  //- span.event-count {{ isMarketValid(earlyMenu, false) ? earlyMenu[menu2].orz && earlyMenu[menu2].orz > 0 ? earlyMenu[menu2].tn - earlyMenu[menu2].orz : earlyMenu[menu2].tn : 0 }}
              li
                a(href='javascript:void(0);' :class="{ 'active' : menu3 == 'orz' && !['favorite'].includes(menu0) }" @click="setMenu2(menuY, 'live', 'orz')")
                  | {{ $t("ui.outright") }}  
                  //- span.event-count {{ isMarketValid(todayMenu, false) ? todayMenu[menu2].orz : 0 }}
      template(v-else)
        template(v-if="menu3 != 'parlay'")
          .prematch-outright(v-if="['live','upcoming','early','today'].includes(menu1)")
            ul.p-0.m-0.d-flex.justify-content-center
              li
                //- template(v-if="isMarketValid(liveMenu, false)")
                a(href='javascript:void(0);' :class="{ 'active' : menu1 == 'live' && !['orz','parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="setMenu1('live')")
                  img(src='/images/live-icon.svg')
                  | {{ $t("ui.live") }} 
                  span.event-count {{ isMarketValid(liveMenu, false) ? liveMenu[menu2].tn : 0 }}              
              li
                //- template(v-if="isMarketValid(todayMenu, false)")
                a(href='javascript:void(0);' :class="{ 'active' : ['today','upcoming'].includes(menu1) && !['orz','parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="setToday()")
                  | {{ $t("ui.today") }}  
                  span.event-count {{ isMarketValid(todayMenu, false) ? todayMenu[menu2].orz && todayMenu[menu2].orz > 0 ? todayMenu[menu2].tn - todayMenu[menu2].orz : todayMenu[menu2].tn : 0 }}
              li
                //- template(v-if="isMarketValid(earlyMenu, false)")
                a.early-dropdown-btn(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && !['orz','parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="market('early', 1)")
                  | {{ $t("ui.early") }}
                  span.event-count {{ isMarketValid(earlyMenu, false) ? earlyMenu[menu2].orz && earlyMenu[menu2].orz > 0 ? earlyMenu[menu2].tn - earlyMenu[menu2].orz : earlyMenu[menu2].tn : 0 }}
              li
                //- template(v-if="isMarketValid(todayMenu, true)")
                a(href='javascript:void(0);' :class="{ 'active' : menu3 == 'orz' && !['favorite'].includes(menu0) }" @click="setOutright()")
                  | {{ $t("ui.outright") }}  
                  span.event-count {{ isMarketValid(todayMenu, false) ? todayMenu[menu2].orz : 0 }}
          .live-upcoming-hours(v-if="['early'].includes(menu1) && !['parlay','orz'].includes(menu3)")
            ul.p-0.m-0.d-flex
              li.flex-grow-1(@click="market('early', 0)")
                a(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && selectedDays == 0 }")
                  | {{ $t("ui.early_all") }}
              li.flex-grow-1(v-for="(item, index) in 7" @click="market('early', item)")
                a(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && selectedDays == item}")
                  | {{ $dayjs().subtract(12, 'hour').add(item, 'day').format("MMM DD (ddd)") }}
          .live-upcoming-hours(v-if="['today','upcoming'].includes(menu1) && !['parlay','orz'].includes(menu3)")
            ul.p-0.m-0.d-flex.justify-content-around
              li.flex-grow-1
                a(href='javascript:void(0);' :class="{ 'active' : ['today'].includes(menu1) }" @click="setMenu1('today')") {{ $t("ui.all") }}
              li.flex-grow-1
                a(href='javascript:void(0);' :class="{ 'active' : ['upcoming'].includes(menu1) && upcomingHours == '1' }" @click="market('upcoming', '1')") 1 {{ $t("ui.hour") }}
              li.flex-grow-1
                a(href='javascript:void(0);' :class="{ 'active' : ['upcoming'].includes(menu1) && upcomingHours == '3' }" @click="market('upcoming', '3')") 3 {{ (language == 'en') ? $t("ui.hour") + 's' : $t("ui.hour") }}
              li.flex-grow-1
                a(href='javascript:void(0);' :class="{ 'active' : ['upcoming'].includes(menu1) && upcomingHours == '6' }" @click="market('upcoming', '6')") 6 {{ (language == 'en') ? $t("ui.hour") + 's' : $t("ui.hour") }}
          sportsItem(
            :order="order"
            :live="liveMenu"
            :today="todayMenu"
            :items="selectedMarket"
            :sports="menuList.sports"
            @save="saveMarket"
          )
        template(v-else)
          //- parlay
          .prematch-outright(v-if="['live','upcoming','early','today'].includes(menu1)")
            ul.p-0.m-0.d-flex.justify-content-center
              li
                //- template(v-if="isMarketValid(parlayMenu, false)")
                a(href='javascript:void(0);' :class="{ 'active' : menu3 == 'parlay' && !menuX && menu1 == 'live' }" @click="setMenu3('parlay','live')")
                  img(src='/images/live-icon.svg')
                  | {{ $t("ui.live") }} 
                  //- span.event-count {{ parlayMenu[menu2].tn }}
              li
                //- template(v-if="isMarketValid(parlayMenu, false)")
                a(href='javascript:void(0);' :class="{ 'active' : menu3 == 'parlay' && !menuX && menu1 == 'today' }" @click="setMenu3('parlay','today')")
                  | {{ $t("ui.today") }}  
                  //- span.event-count {{ parlayMenu[menu2].tn }}
              li
                //- template(v-if="isMarketValid(parlayMenu, false)")
                a.early-dropdown-btn(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && ['parlay'].includes(menu3) && !['favorite'].includes(menu0) }" @click="market('parlay', 0)")
                  | {{ $t("ui.early") }}
                  //- span.event-count {{ parlayMenu[menu2].tn }}
          .live-upcoming-hours(v-if="['early'].includes(menu1) && !['parlay','orz'].includes(menu3)")
            ul.p-0.m-0.d-flex
              li.flex-grow-1(@click="market('parlay', 0)")
                a(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && selectedDays == 0 }")
                  | {{ $t("ui.early_all") }}
              li.flex-grow-1(v-for="(item, index) in 7" @click="market('parlay', item)")
                a(href="javascript:void(0);" :class="{ 'active' : menu1 == 'early' && selectedDays == item}")
                  | {{ $dayjs().subtract(12, 'hour').add(item, 'day').format("MMM DD (ddd)") }}
          sportsItem(
            :order="order"
            :live="liveMenu"
            :today="todayMenu"
            :items="parlayMenu"
            :sports="menuList.sports"
            @save="saveMarket"
          )
      .function-bar
        template(v-if="menu0 != 'event'")
          .function-btn.d-flex.align-items-center.justify-content-center(v-if="!['favorite'].includes(menu0)")
            .btn-sm.btn-parlay-early(:class="{ 'active' : menu3 == 'parlay' && !menuX }" @click="setMenu1('parlay')") {{ $t("ui.parlay") }}
            .btn-sm.btn-mmo-parlay(v-if="mmoMode && menuList.parlay_count > 0" :class="{ 'active' : menuX }" @click="setMenu0('mmoparlay')") {{ $t("ui.mmo_parlay") }}
            .btn-sm.btn-league(@click="go('/parlaygenerator')")
              i.fad.fa-random
          //- .dropdown
          //-   .btn-sm.dropdown-btn(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false') Asia View
          //-   ul.dropdown-menu
          //-     li
          //-       a.dropdown-item.active Asia View
          //-     li
          //-       a.dropdown-item(href='euro-view.html') Euro View
          //- .dropdown(v-if="!['favorite'].includes(menu0)")
          //-   .btn-sm.btn-parlay.dropdown-btn(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false') {{ parlayMode === 0 ? $t("ui.parlay") : $t("ui.mmo_parlay") }}
          //-   ul.parlay-dropdown-filter-menu
          //-     li
          //-       a.dropdown-item(:class="{ 'active' : menu3 == 'parlay' && !menuX }" @click="setMenu1('parlay')") {{ $t("ui.parlay") }}
          //-     li
          //-       a.dropdown-item(v-if="mmoMode && menuList.parlay_count > 0" :class="{ 'active' : menuX }" @click="setMenu0('mmoparlay')") {{ $t("ui.mmo_parlay") }}
          //-     li
          //-       a.dropdown-item(@click="go('/parlaygenerator')") {{ $t("ui.parlay_generator") }}
          //-     li.close {{ $t("ui.close") }}
        .function-item
          .btn-league(@click="toggleSearch()")
            i.fas.fa-trophy-alt
          .btn-favorite(:class="{ 'active' : ['favorite'].includes(menu0) }" @click="toggleFavorite()")
            img(src='/images/favorite-active.svg?v=12')
          .btn-sm.btn-collapse(
            @click="toggleAll()"
            :class="[0,1,2,3,4,5,6].includes($dayjs().day()) && ['today'].includes(menu1) || ['0','1','2','3','4','5','6'].includes(selectedDays) && ['early'].includes(menu1) || ['event'].includes(menu0) && ['early'].includes(menu1) ? 'close-all' : 'open-all'"
          )
      #all-leagues.accordion-all-leagues
        template(v-if="marketKeys.length > 0")
          template(v-if="menuX == true")
            // MMO PARLAY ONLY
            template(v-for="(ml, mk) in liveMarketKeys")
              template(v-if="marketList[ml].xp")
                template(v-for="(ll, lk) in marketList[ml].leagueList")
                  template(v-if="ll.xp")
                    mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                    template(v-for="(mml, mmk) in ll.matchList")
                      template(v-if="mml.xp")
                        mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
            template(v-for="(ml, mk) in todayMarketKeys")
              template(v-if="marketList[ml].xp")
                template(v-for="(ll, lk) in marketList[ml].leagueList")
                  template(v-if="ll.xp")
                    mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                    template(v-for="(mml, mmk) in ll.matchList")
                      template(v-if="mml.xp")
                        mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
            template(v-for="(ml, mk) in earlyMarketKeys")
              template(v-if="marketList[ml].xp")
                template(v-for="(ll, lk) in marketList[ml].leagueList")
                  template(v-if="ll.xp")
                    mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                    template(v-for="(mml, mmk) in ll.matchList")
                      template(v-if="mml.xp")
                        mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
          template(v-else)
            template(v-for="(ml, mk) in liveMarketKeys")
              template(v-for="(ll, lk) in marketList[ml].leagueList")
                template(v-if="ll.betTypeId != 'orz'")
                  //- small {{ ll.ptype }} {{ ll.matchList.length }} {{ ll.leagueName }}
                  mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  template(v-if="![40].includes(ll.sportsId)")
                    template(v-for="(mml, mmk) in ll.matchList")
                      mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
                  template(v-else)
                    MatchHDPOUMAINOdds(:source="ll")
                template(v-else)
                  mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  MatchORZOdds(:source="ll")
            template(v-for="(ml, mk) in todayMarketKeys")
              template(v-for="(ll, lk) in marketList[ml].leagueList")
                template(v-if="ll.betTypeId != 'orz'")
                  mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  template(v-if="![40].includes(ll.sportsId)")
                    template(v-for="(mml, mmk) in ll.matchList")
                      mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
                  template(v-else)
                    MatchHDPOUMAINOdds(:source="ll")
                template(v-else)
                  mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  MatchORZOdds(:source="ll")
            template(v-for="(ml, mk) in earlyMarketKeys")
              template(v-for="(ll, lk) in marketList[ml].leagueList")
                template(v-if="ll.betTypeId != 'orz'")
                  mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  template(v-if="![40].includes(ll.sportsId)")
                    template(v-for="(mml, mmk) in ll.matchList")
                      mainItem(:source="mml" :index="parseInt(mmk)" :key="mml.id")
                  template(v-else)
                    MatchHDPOUMAINOdds(:source="ll")
                template(v-else)
                  mainItem(:source="ll" :index="parseInt(lk)" :key="ll.id")
                  MatchORZOdds(:source="ll")
        template(v-else)
          .no-data(v-if="!loading.logo")
            .no-data-wrapper
              img(src='/images/no_data.svg?v=12')
              span.text {{ $t("error.matchHide") }}
      .market-loading-overlay(v-if="loading.logo")
        .loader
      //- .swith-market-btn
      //-   template(v-if="menu1 != 'live'")
      //-     template(v-if="menu3 == 'parlay'")
      //-       a(href='javascript:void(0);' @click="setMenu3('parlay','live')")
      //-         span {{ $t("ui.go_live_matches") }}
      //-         span.icon
      //-           i.fas.fa-caret-right
      //-     template(v-else)
      //-       a(href='javascript:void(0);' @click="setMenu1('live')")
      //-         span {{ $t("ui.go_live_matches") }}
      //-         span.icon
      //-           i.fas.fa-caret-right
      //-   template(v-else)
      //-     template(v-if="menu3 == 'parlay'")
      //-       a(href='javascript:void(0);' @click="setMenu3('parlay','today')")
      //-         span {{ $t("ui.go_today_matches") }}
      //-         span.icon
      //-           i.fas.fa-caret-right
      //-     template(v-else)
      //-       a(href='javascript:void(0);' @click="setMenu1('today')")
      //-         span {{ $t("ui.go_today_matches") }}
      //-         span.icon
      //-           i.fas.fa-caret-right
  footerNav
</template>

<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import mainItem from "@/components/mobile/main/mainItem";
import refreshButton from "@/components/mobile/main/refreshButton";
import MatchORZOdds from "@/components/mobile/main/xmatch/matchORZOdds";
import MatchHDPOUMAINOdds from "@/components/mobile/main/xmatch/matchHDPOUMAINOdds";
import mixinMain from "@/library/mixinMain";
import mixinDelay from "@/library/mixinDelay";
import { EventBus } from "@/library/_event-bus.js";
import sportsItem from "@/components/mobile/main/sportsItem";

import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

import egames from "@/components/mobile/egames";

export default {
  components: {
    toolBar,
    footerNav,
    mainItem,
    refreshButton,
    MatchORZOdds,
    MatchHDPOUMAINOdds,
    sportsItem,
    Marquee,
    egames
  },
  mixins: [mixinMain, mixinDelay],
  data() {
    return {
      gamesList: config.gamesList,
      state: {
        GET_LIVE: false,
        GET_NONLIVE: false,
        GET_MARKET: false,
        GET_TM: false,
        INVALIDATE: false
      },
      counter: {
        GET_LIVE: 0,
        GET_NONLIVE: 0,
        GET_MARKET: 0,
        GET_TM: 0,
        INVALIDATE: 0
      },
      func: {
        GET_LIVE: null,
        GET_NONLIVE: null,
        GET_MARKET: null,
        GET_TM: null,
        INVALIDATE: null
      }
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    isNonLive() {
      if (["all"].includes(this.menu0)) {
        if (["orz", "parlay"].includes(this.menu3)) {
          return true;
        } else {
          if (["early", "parlay"].includes(this.menu1)) {
            return true;
          }
        }
      } else {
        return false;
      }
      return false;
    },
    selectedMarket() {
      switch (this.menu1) {
        case "live":
          return this.liveMenu;
        case "early":
          return this.earlyMenu;
        default:
          return this.todayMenu;
      }
    }
  },
  created() {
    // First paint must show the loader, not the empty "no market" state.
    if (this.isLoggedIn) {
      this.loading.logo = true;
    }
  },
  destroyed() {
    EventBus.$off("GET_LIVE_COUNT", this.handleLive);
    EventBus.$off("GET_NONLIVE_COUNT", this.handleNonLive);
    EventBus.$off("GET_MARKET_COUNT", this.handleMarket);
    EventBus.$off("GET_TM_COUNT", this.handleTm);
    EventBus.$off("GET_LIVE", this.runLive);
    EventBus.$off("GET_NONLIVE", this.runNonLive);
    EventBus.$off("GET_MARKET", this.runMarket);
    EventBus.$off("GET_TM", this.runTm);
    EventBus.$off("INVALIDATE", this.runInvalidate);
  },
  mounted() {
    // $('.btn-parlay').click( function(event){
    //   event.stopPropagation();
    //   $('.parlay-dropdown-filter-menu').slideDown();
    // });
    // $('.parlay-dropdown-filter-menu .close').click( function(event){
    //   event.stopPropagation();
    //   $('.parlay-dropdown-filter-menu').slideUp();
    // });

    EventBus.$on("GET_LIVE_COUNT", this.handleLive);
    EventBus.$on("GET_NONLIVE_COUNT", this.handleNonLive);
    EventBus.$on("GET_MARKET_COUNT", this.handleMarket);
    EventBus.$on("GET_TM_COUNT", this.handleTm);
    EventBus.$on("GET_LIVE", this.runLive);
    EventBus.$on("GET_NONLIVE", this.runNonLive);
    EventBus.$on("GET_MARKET", this.runMarket);
    EventBus.$on("GET_TM", this.runTm);
    EventBus.$on("INVALIDATE", this.runInvalidate);
    this.func.GET_LIVE = this.debounce(this.getLive, 500);
    this.func.GET_NONLIVE = this.debounce(this.getNonLive, 500);
    this.func.GET_MARKET = this.debounce(this.getMarket, 500);
    this.func.GET_TM = this.debounce(this.getTM, 500);
    this.func.INVALIDATE = this.debounce(this.invalidate, 500);
    // Mixin schedules INVALIDATE after 1s; start the first fetch immediately instead.
    if (this.invalidateTimer != null) {
      clearTimeout(this.invalidateTimer);
      this.invalidateTimer = null;
    }
    if (this.isLoggedIn) {
      EventBus.$emit("INVALIDATE");
    }
  },
  methods: {
    isMarketValid(e, orz) {
      return e && e[this.menu2] && e[this.menu2].tn && e[this.menu2].tn > 0;
      // if(orz) {
      //   return e && e[this.menu2] && e[this.menu2].orz && e[this.menu2].orz > 0
      // } else {
      //   return e && e[this.menu2] && e[this.menu2].tn && e[this.menu2].tn > 0
      // }
    },
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    runLive(e) {
      this.state.GET_LIVE = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
      }, 1000);
    },
    runNonLive(e) {
      this.state.GET_NONLIVE = true;
      setTimeout(() => {
        this.state.GET_NONLIVE = false;
      }, 2000);
    },
    runMarket(e) {
      this.state.GET_LIVE = true;
      this.state.GET_NONLIVE = true;
      this.state.GET_MARKET = true;
      this.state.GET_TM = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
        this.state.GET_NONLIVE = false;
        this.state.GET_MARKET = false;
        this.state.GET_TM = false;
      }, 3000);
    },
    runInvalidate(e) {
      this.state.GET_LIVE = true;
      this.state.GET_NONLIVE = true;
      this.state.GET_MARKET = true;
      this.state.GET_TM = true;
      this.state.INVALIDATE = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
        this.state.GET_NONLIVE = false;
        this.state.GET_MARKET = false;
        this.state.GET_TM = false;
        this.state.INVALIDATE = false;
      }, 5000);
    },
    runTm(e) {
      this.state.GET_TM = true;
      setTimeout(() => {
        this.state.GET_TM = false;
      }, 3000);
    },
    handleLive(e) {
      this.counter.GET_LIVE = e;
    },
    handleNonLive(e) {
      this.counter.GET_NONLIVE = e;
    },
    handleMarket(e) {
      this.counter.GET_MARKET = e;
    },
    handleTm(e) {
      this.counter.GET_TM = e;
    },
    getLive() {
      EventBus.$emit("GET_LIVE");
    },
    getNonLive() {
      EventBus.$emit("GET_NONLIVE");
    },
    getMarket() {
      EventBus.$emit("GET_MARKET");
    },
    getTM(e) {
      EventBus.$emit("GET_TM", e);
    },
    invalidate() {
      EventBus.$emit("INVALIDATE");
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
      }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    go(e) {
      this.$router.push(e).catch(err => {});
    },
    getMenu(e) {
      if (!this.menuList) {
        return {};
      }

      if (!this.menuList.menu) {
        return {};
      }

      switch (e) {
        case "early":
          if (this.menuList.menu["1"]) return this.menuList.menu["1"];
          else return {};
        case "today":
          if (this.menuList.menu["2"]) return this.menuList.menu["2"];
          else return {};
        case "live":
          if (this.menuList.menu["3"]) return this.menuList.menu["3"];
          else return {};
        case "parlay":
          if (this.menuList.menu["4"]) return this.menuList.menu["4"];
          else return {};
        default:
          return {};
      }
    },
    setMenu0(e) {
      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};

      if (e == "mmoparlay") {
        $(".btn-mmo-parlay").toggleClass("active");
        if ($(".btn-mmo-parlay").hasClass("active")) {
          mi5["menuX"] = true;
          this.$store.dispatch("layout/setOptions", { property: "parlay", value: this.menu2 });
        } else {
          if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
          mi5["menuX"] = false;
          this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
          e = "today";
        }
      } else {
        mi5["menuX"] = false;
        if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
        this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
        $(".btn-mmo-parlay").removeClass("active");
      }

      // var mi5 = {};
      // mi5["menuX"] = true;
      mi5["menuY"] = "0";
      mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
          break;
        case "mmoparlay":
          mi5["menu0"] = "parlay";
          mi5["menu2"] = 1; //force parlay mode to soccer always
          mi5["menu3"] = "parlay";
          break;
        default:
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = "1";
          if (this.menu2 != null) {
            choosenSport = this.menu2.toString();
          }
          if (!sports.includes(choosenSport)) {
            choosenSport = sports[0];
          }
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    // Not a computed: $dayjs() is not reactive, so the cached value would go stale past midnight
    isTodayUpcomingDay() {
      return config.todayUpcomingDays.includes(this.$dayjs().day());
    },
    // "Today" tab: opens on the upcoming-hours filter on the days listed in config.todayUpcomingDays,
    // otherwise on the full today list. The "All" sub-tab still calls setMenu1("today") directly.
    setToday() {
      this.setMenu1("today", this.isTodayUpcomingDay());
    },
    setMenu1(e, useUpcomingHours) {
      this.$store.dispatch("layout/setSelectedMatch", null);
      if (e == "parlay") {
        $(".btn-parlay-early").toggleClass("active");
        if ($(".btn-parlay-early").hasClass("active")) {
          this.$store.dispatch("layout/setOptions", { property: "parlay", value: this.menu2 });
        } else {
          if (EventBus.cancelParlay) EventBus.cancelParlay();
          this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
          e = "today";
        }
      } else {
        if (EventBus.cancelParlay) EventBus.cancelParlay();
        this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
        $(".btn-parlay-early").removeClass("active");
      }

      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
        case "parlay":
          mi5["menu0"] = "all";
          mi5["menu1"] = "today";
          // mi5["menu2"] = 1; //force parlay mode to soccer always
          mi5["menu3"] = "parlay";
          break;
        default:
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = "1";
          if (this.menu2 != null) {
            choosenSport = this.menu2.toString();
          }
          if (!sports.includes(choosenSport)) {
            choosenSport = sports[0];
          }
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      // Switch the resolved today market over to the upcoming-hours filter, same shape as market("upcoming", d)
      if (useUpcomingHours) {
        config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    setMenu2(e, m, bt) {
      if (EventBus.setMenu0) {
        if (bt == "orz") {
          EventBus.setMenu0("event", e, m, bt);
        } else {
          EventBus.setMenu0("event", e, m);
        }
      }
    },
    setMenu3(e, f) {
      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
        case "parlay":
          mi5["menu0"] = "all";
          mi5["menu1"] = f;
          mi5["menu3"] = "parlay";
          break;
        default:
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = "1";
          if (this.menu2 != null) {
            choosenSport = this.menu2.toString();
          }
          if (!sports.includes(choosenSport)) {
            choosenSport = sports[0];
          }
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    market(e, d) {
      this.$store.dispatch("layout/setSelectedMatch", null);
      if (e != "parlay") {
        $(".btn-parlay-early").removeClass("active");
      }
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      switch (e) {
        case "live":
          this.$store.dispatch("layout/setSelectedDays", "1");
          mi5["menu0"] = "live";
          mi5["menu1"] = "live";
          mi5["menu3"] = "hdpou";
          break;
        case "today":
          this.$store.dispatch("layout/setSelectedDays", "1");
          mi5["menu0"] = "all";
          mi5["menu1"] = "today";
          mi5["menu3"] = "hdpou";
          break;
        case "early":
          this.$store.dispatch("layout/setSelectedDays", d.toString());
          mi5["menu0"] = "all";
          mi5["menu1"] = "early";
          mi5["menu3"] = "hdpou";
          break;
        case "upcoming":
          this.$store.dispatch("layout/setUpcomingHours", d.toString());
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          mi5["menu0"] = "upcoming";
          mi5["menu1"] = "upcoming";
          mi5["menu3"] = "hdpou";
          break;
        case "parlay":
          this.$store.dispatch("layout/setSelectedDays", d.toString());
          mi5["menu0"] = "all";
          mi5["menu1"] = "early";
          mi5["menu3"] = "parlay";
          break;
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        // this.resetSelectLeague();
        // this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    setOutright() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      this.resetSelectLeague();
      this.clearSearch();
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = "today";
      mi5["menu3"] = "orz";
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE", mi5);
    },
    toggleSearch() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      this.$router.push("/select_league").catch(err => {});
    },
    toggleFavorite() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      if (this.menu0 != "favorite") {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "favorite";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      } else {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "all";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
    },
    toggleAll() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        // open
        elem.removeClass("close-all");
        elem.addClass("open-all");
        setTimeout(() => {
          $(".collapse").addClass("show");
          $(".collapse-head")
            .removeClass("collapsed")
            .attr("aria-expanded", "true");
        }, 100);
      } else {
        // close
        elem.removeClass("open-all");
        elem.addClass("close-all");
        setTimeout(() => {
          $(".collapse").removeClass("show");
          $(".collapse-head")
            .addClass("collapsed")
            .attr("aria-expanded", "false");
        }, 100);
      }
    },
    saveLive(e) {
      this.resetSelectLeague();
      this.clearSearch();
      for (var i = 0; i < config.gamesList.length; i++) {
        e[config.gamesList[i]] = false;
      }
      this.$store.dispatch("layout/setOptions", { property: "live", value: e });
      EventBus.$emit("INVALIDATE");
    },
    saveToday(e) {
      this.resetSelectLeague();
      this.clearSearch();
      this.$store.dispatch("layout/setOptions", { property: "live", value: e });
      // this.market("upcoming", this.upcomingHours);
      // EventBus.$emit("INVALIDATE");
    },
    saveParlay(e) {
      this.resetSelectLeague();
      this.clearSearch();
      for (var i = 0; i < config.gamesList.length; i++) {
        e[config.gamesList[i]] = false;
      }
      this.$store.dispatch("layout/setOptions", { property: "parlay", value: e });
      // EventBus.$emit("INVALIDATE");
    },
    saveMarket(e) {
      if (this.menu3 != "parlay") {
        if (this.menu1 == "live") {
          this.saveLive(e);
        } else {
          this.saveToday(e);
        }
      } else {
        this.saveParlay(e);
      }
    }
  }
};
</script>
